<template>



    <div class="menuItem" @click="open('MobileProductSearch')">
        <i class="fa fa-search"></i>
         {{$t('productbrowsing')}}
    </div>

    <div class="menuItem" @click="open('MobileDataDownload')">
        <i class="fa fa-briefcase"></i>
         {{$t('filedown')}}
    </div>

    <div class="menuItem" @click="open('MobileProgress')">
        <i class="fa fa-battery-three-quarters"></i>
         {{$t('projectprogress')}}
    </div>

    <div class="menuItem" v-if="role.showAuditMenu" @click="open('MobileApprove')">
        <i class="fa fa-check"></i>
         {{$t('approve')}}
    </div>
 
    <div class="menuItem" v-if="role.showAuditMenu" @click="open('MobileMeasure')">
        <i class="fa fa-bug"></i>
         {{$t('faultmeasure')}}
    </div>



</template>

<script>
import getRole from '../common/role'
export default {
    data() {
        return {
            role: {}
        }
    },
    methods: {
        open(router) {

            if (router == "MobileDataDownload") {
                this.$router.push({
                    path: 'MobileDataDownload', query:
                    {
                        catlog: '/'  
                    }
                })
                return
            }

            this.$router.push(router);
        }
    },
    mounted() {
        this.role = getRole();
    }

}
</script>

<style>
.title {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: aliceblue;
    font-weight: bold;
    font-size: 20px;
}

.menuItem {
    height: 60px;
    line-height: 60px;
    color: black;
    margin: 40px;
    background-color: gainsboro;
}

.menuItem:hover {
    background-color: darkgray;
}
</style>